<div class="preview-box" [ngClass]="{'minimized': isMinimized}">
    <button class="minimize-btn" (click)="toggleMinimize()">{{ isMinimized ? '+' : '-' }}</button>
    <ng-container *ngIf="!isMinimized">
        <h2>Preview</h2>
        <p *ngIf="activeQuadrant > 0">Posição atual: <b>quadrante {{hasInvertedQuadrants ? invertedQuadrants[activeQuadrant - 1] : activeQuadrant}}</b></p>
        <ion-grid *ngIf="nineboxConfig && nineboxConfig.xAxis && nineboxConfig.yAxis" style="display: flex; flex-direction: column-reverse">
            <ion-row *ngFor="let row of nineboxConfig.yAxis.values; let columnIndex = index" class="row">
                <ion-col
                    *ngFor="let cell of nineboxConfig.xAxis.values; let rowIndex = index"
                    class="cell"
                    [ngClass]="{'selected': getQuadrantNumber(rowIndex, columnIndex) == activeQuadrant}"
                    [ngStyle]="{'background': nineboxConfig.colors[getQuadrantNumber(rowIndex, columnIndex)]}"
                ></ion-col>
            </ion-row>
        </ion-grid>
    </ng-container>
    <ng-container *ngIf="isMinimized">
        <h6>Preview 9Box</h6>
    </ng-container>
</div>
